const gallery = [
  "M4 4.33a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM14.33 5.67V9.7a2.64 2.64 0 0 1-2.63 2.64H5V13c0 .92.75 1.67 1.66 1.67h7.67A1.67 1.67 0 0 0 16 13V7.33a1.67 1.67 0 0 0-1.67-1.66z",
  "M1.63 2.66H11.7c.17 0 .3.14.3.3v4.1L9.9 4.6a1.21 1.21 0 0 0-.9-.4 1.17 1.17 0 0 0-.89.41L5.63 7.58l-.8-.8a1.17 1.17 0 0 0-1.66 0L1.33 8.62V2.96c0-.16.14-.3.3-.3zM11.7 1.33H1.63A1.63 1.63 0 0 0 0 2.96V9.7c0 .12.01.23.04.34a.5.5 0 0 0 .12.47l.1.06a1.63 1.63 0 0 0 1.37.76H11.7c.9 0 1.64-.73 1.64-1.63V2.96a1.63 1.63 0 0 0-1.64-1.63z"
];
export {
  gallery
};
//# sourceMappingURL=gallery.js.map
